import { render, staticRenderFns } from "./DinnerTag.vue?vue&type=template&id=9e2b2074&scoped=true&"
import script from "./DinnerTag.vue?vue&type=script&lang=js&"
export * from "./DinnerTag.vue?vue&type=script&lang=js&"
import style0 from "./DinnerTag.vue?vue&type=style&index=0&id=9e2b2074&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9e2b2074",
  null
  
)

export default component.exports